/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairLocationType {
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY'
}

